"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M1 3V1H13V4",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M13 15L1 15L1 3",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.54297 8.27344L7.60938 6.3125H8.95703L7.30078 9.13281L9 12H7.63672L6.54297 10.0078L5.44922 12H4.08594L5.78516 9.13281L4.12891 6.3125H5.47656L6.54297 8.27344ZM10.7656 11.0586H13.2539V12H9.59375V6.3125H10.7656V11.0586ZM16.8789 10.5078C16.8789 10.2865 16.8008 10.1172 16.6445 10C16.4883 9.88021 16.207 9.75521 15.8008 9.625C15.3945 9.49219 15.0729 9.36198 14.8359 9.23438C14.1901 8.88542 13.8672 8.41536 13.8672 7.82422C13.8672 7.51693 13.9531 7.24349 14.125 7.00391C14.2995 6.76172 14.5482 6.57292 14.8711 6.4375C15.1966 6.30208 15.5612 6.23438 15.9648 6.23438C16.3711 6.23438 16.7331 6.30859 17.0508 6.45703C17.3685 6.60286 17.6146 6.8099 17.7891 7.07812C17.9661 7.34635 18.0547 7.65104 18.0547 7.99219H16.8828C16.8828 7.73177 16.8008 7.52995 16.6367 7.38672C16.4727 7.24089 16.2422 7.16797 15.9453 7.16797C15.6589 7.16797 15.4362 7.22917 15.2773 7.35156C15.1185 7.47135 15.0391 7.63021 15.0391 7.82812C15.0391 8.01302 15.1315 8.16797 15.3164 8.29297C15.5039 8.41797 15.7786 8.53516 16.1406 8.64453C16.8073 8.84505 17.293 9.09375 17.5977 9.39062C17.9023 9.6875 18.0547 10.0573 18.0547 10.5C18.0547 10.9922 17.8685 11.3789 17.4961 11.6602C17.1237 11.9388 16.6224 12.0781 15.9922 12.0781C15.5547 12.0781 15.1562 11.9987 14.7969 11.8398C14.4375 11.6784 14.1628 11.4583 13.9727 11.1797C13.7852 10.901 13.6914 10.5781 13.6914 10.2109H14.8672C14.8672 10.8385 15.2422 11.1523 15.9922 11.1523C16.2708 11.1523 16.4883 11.0964 16.6445 10.9844C16.8008 10.8698 16.8789 10.7109 16.8789 10.5078Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;